var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41_1645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2606 15.7687L11.4456 11.9538M11.4456 11.9538L7.63055 15.7687M11.4456 11.9538V20.5375M19.4475 18.0482C20.3777 17.5411 21.1126 16.7386 21.5361 15.7674C21.9596 14.7963 22.0476 13.7117 21.7863 12.685C21.525 11.6582 20.9292 10.7477 20.0929 10.0972C19.2566 9.44671 18.2275 9.0932 17.1681 9.0925H15.9663C15.6776 7.97589 15.1396 6.93925 14.3926 6.06052C13.6456 5.18179 12.7091 4.48384 11.6536 4.01913C10.598 3.55442 9.45083 3.33505 8.29829 3.37752C7.14575 3.41998 6.01783 3.72317 4.99933 4.2643C3.98083 4.80542 3.09825 5.5704 2.41795 6.50172C1.73765 7.43303 1.27733 8.50646 1.0716 9.64128C0.865862 10.7761 0.920069 11.9428 1.23014 13.0537C1.54021 14.1645 2.09808 15.1906 2.8618 16.0549",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41_1645"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.89,
    height: 22.89,
    fill: "white",
    transform: "translate(0 0.508759)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.6acd2cf667516779e1b7017295b749b7.svg";
export { ForwardRef as ReactComponent };